import Link from 'next/link';
import React from 'react';
import { Crumb } from 'utils/breadcrumb-util';

interface IProps {
  className?: string;
  crumb: Crumb;
}

export const CrumbBlock: React.FC<IProps> = ({ className, crumb }) => (
  <Link key={crumb.href} href={crumb.href} className={`cursor-pointer last:text-white hover:underline ${className}`}>
    <i className='fas fa-chevron-right mr-1.5 text-xs md:mr-2' />
    <span className='align-middle'>{crumb.name}</span>
  </Link>
);
